export const exportJobsEndpoints = {
  createExportJob: { method: 'post', path: '/export' },
  getExportJob: { method: 'get', path: '/export/{exportJobId}' },
} as const
